module.exports = __webpack_public_path__ + "static/media/circle-view-off.1bc661b6.svg";